import React, { useState } from 'react';
import { useGetApiRequests, useNavigate, useForm, SubmitHandler, Controller, yupResolver, Button, Input, Heading, ErrorMessage } from '../../common/CommonExport';
import { ForgotPasswordSchema } from './ForgotPasswordSchema';
import { useLocation } from 'react-router-dom';
import ForgotPasswordAlert from './forgotPasswordAlert';
import PopupModal from '../employee/employee-details/employee-profile/modal/PopupModal';
interface ForgotPasswordPayload {
    email: string;
}

const ForgotPasswordForm: React.FC = () => {
    const { search } = useLocation();
    const email: any = new URLSearchParams(search).get("email")
    const [mailAlert, setMailAlert] = useState<any>(false);
    const employeeForgotPassword = useGetApiRequests('employeeForgetPassword', 'POST');
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [modalerrMessage, setModalErrMessage] = useState('')
    const [popModal, setPopModal] = useState(false)
    const [modalResponse, setModalResponse] = useState('')
    const [modalButtonShow, setmodalButtonShow] = useState(true)
    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm<ForgotPasswordPayload>({
        resolver: yupResolver(ForgotPasswordSchema) as any,
        defaultValues: {
            email: email !== '' && email !== undefined ? email : '',
        },
    });

    const onSubmit: SubmitHandler<ForgotPasswordPayload> = (data: any) => {
        const param: Object = {
            email: data.email !== '' && data.email !== undefined ? data.email : '',
        };
        setLoader(true);
        employeeForgotPassword('', param)
            .then((response: any) => {
                setLoader(false);
                setMailAlert(true)
            })
            .catch((err: any) => {
                setPopModal(true)
                setmodalButtonShow(false)
                setModalErrMessage(err?.response?.data?.data || err?.response?.data?.status?.message || "Something went wrong")
                setModalResponse('error')
                setTimeout(() => {
                    handleClosePopUpModal();
                    setLoader(false);
                }, 1500)
            });
    };

    const navigation = (): void => {
        navigate('/login');
    };

    const handleClosePopUpModal = () => {
        setPopModal(false)
    }
    return (
        <div className='w-full h-auto md:min-h-screen flex items-center justify-center p-[20px] md:p-0 '>
            <div className='w-full mx-auto my:auto bg-transparent'>
                <Heading title='Forgot Password?' subheading='We’ll help you reset it and get back on track.' />
                <div className=' w-auto md:w-9/12'>
                    <form onSubmit={handleSubmit(onSubmit)} noValidate>
                        <div className='relative z-0 mt-12 mb-4 md:my-12 '>
                            <Controller name='email' control={control} render={({ field }) => <Input type='email' id='email' label='Email Address*' control={control} {...field} hasError={!!errors.email} />} />
                        </div>
                        {errors.email && <ErrorMessage message={errors.email.message} />}

                        <div className='flex items-center justify-between mt-11 md:mt-8'>
                            <div className='mb-4'>
                                <Button variant='secondary' type='button' label='Back' onClick={() => navigation()} />
                            </div>
                            <Button loading={loader} variant='primary' type='submit' label='Reset Password' />
                        </div>
                    </form>
                </div>
            </div>
            {mailAlert && <ForgotPasswordAlert open={mailAlert} setMailAlert={setMailAlert} />}
            {/* {loader && <Loader />} */}
            {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}
        </div>
    );
};

export default ForgotPasswordForm;
